import { cva } from "class-variance-authority";
const buttonVariants = cva(
  "cursor-pointer inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2  disabled:opacity-100 disabled:cursor-not-allowed text-center",
  {
    variants: {
      variant: {
        solid: "",
        glassy: "",
        outline: "",
        text: ""
      },
      size: {
        xs: "min-h-8 min-w-[6.25rem] px-2 text-xs font-medium rounded-sm gap-2",
        sm: "min-h-9 min-w-[7.5rem] px-4 py-2 text-xs font-medium rounded-sm gap-2",
        md: " min-h-14 min-w-[10.625rem] px-6 text-base font-bold rounded-lg gap-2.5",
        lg: "min-h-[3.875rem] min-w-[12rem] px-6 text-lg font-bold rounded-lg gap-4",
        icon: "size-6 p-4 rounded-lg",
        loose: ""
      },
      colorPalette: {
        blue: "",
        green: "",
        slate: "",
        warmGreen: "",
        orange: "",
        red: ""
      }
    },
    compoundVariants: [
      {
        variant: "solid",
        colorPalette: "blue",
        className: "bg-blue-600 text-white hover:bg-blue-700 active:bg-blue-800 disabled:bg-slate-400"
      },
      {
        variant: "solid",
        colorPalette: "green",
        className: "bg-green-600 text-white hover:bg-green-700 active:bg-green-800 disabled:bg-slate-400"
      },
      {
        variant: "solid",
        colorPalette: "warmGreen",
        className: "bg-warmGreen-500 text-white hover:bg-warmGreen-600 active:bg-warmGreen-700 disabled:bg-slate-400"
      },
      {
        variant: "solid",
        colorPalette: "orange",
        className: "bg-orange-500 text-white hover:bg-orange-600 active:bg-orange-700 disabled:bg-slate-400"
      },
      {
        variant: "solid",
        colorPalette: "red",
        className: "bg-red-500 text-white hover:bg-red-600 active:bg-red-700 disabled:bg-slate-400"
      },
      {
        variant: "glassy",
        colorPalette: "blue",
        className: "bg-blue-200 text-blue-600 hover:bg-blue-300/80 active:bg-blue-300 disabled:bg-slate-100 disabled:text-slate-400"
      },
      {
        variant: "glassy",
        colorPalette: "green",
        className: "bg-green-200 text-green-600 hover:bg-green-300/80 active:bg-green-300 disabled:bg-slate-100 disabled:text-slate-400"
      },
      {
        variant: "glassy",
        colorPalette: "warmGreen",
        className: "bg-warmGreen-200 text-warmGreen-500 hover:bg-warmGreen-300/80 active:bg-warmGreen-300 disabled:bg-slate-100 disabled:text-slate-400"
      },
      {
        variant: "glassy",
        colorPalette: "orange",
        className: "bg-orange-200 text-orange-500 hover:bg-orange-300/80 active:bg-orange-300 disabled:bg-slate-100 disabled:text-slate-400"
      },
      {
        variant: "glassy",
        colorPalette: "slate",
        className: "bg-white text-slate-500 hover:bg-white/60 active:bg-slate-50 disabled:bg-slate-300 disabled:text-slate-400"
      },
      {
        variant: "glassy",
        colorPalette: "red",
        className: "bg-red-200 text-red-500 hover:bg-red-300/80 active:bg-red-300 disabled:bg-slate-100 disabled:text-slate-400"
      },
      {
        variant: "outline",
        colorPalette: "blue",
        className: "border border-blue-600 text-blue-600 hover:border-blue-700 hover:text-blue-700 active:border-blue-800 active:text-blue-800 disabled:border-slate-400 disabled:text-slate-400"
      },
      {
        variant: "outline",
        colorPalette: "green",
        className: "border border-green-600 text-green-600 hover:border-green-700 hover:text-green-700 active:border-green-800 active:text-green-800 disabled:border-slate-400 disabled:text-slate-400"
      },
      {
        variant: "outline",
        colorPalette: "warmGreen",
        className: "border border-warmGreen-500 text-warmGreen-500 hover:border-warmGreen-600 hover:text-warmGreen-600 active:border-warmGreen-700 active:text-warmGreen-700 disabled:border-slate-400 disabled:text-slate-400"
      },
      {
        variant: "outline",
        colorPalette: "orange",
        className: "border border-orange-500 text-orange-500 hover:border-orange-600 hover:text-orange-600 active:border-orange-700 active:text-orange-700 disabled:border-slate-400 disabled:text-slate-400"
      },
      {
        variant: "outline",
        colorPalette: "red",
        className: "border border-red-500 text-red-500 hover:border-red-600 hover:text-red-600 active:border-red-700 active:text-red-700 disabled:border-slate-400 disabled:text-slate-400"
      },
      {
        variant: "solid",
        colorPalette: "slate",
        className: " bg-slate-200 text-slate-900 hover:bg-slate-300  active:bg-slate-400 disabled:bg-slate-100 disabled:text-slate-200 opacity-80"
      },
      {
        variant: "outline",
        colorPalette: "slate",
        className: "border border-slate-300 text-slate-900 hover:border-slate-400  active:border-slate-500 active:text-slate-500 disabled:border-slate-200 disabled:text-slate-400 opacity-80"
      },
      {
        variant: "text",
        colorPalette: "slate",
        className: "bg-transparent text-slate-600 hover:text-slate-700 active:text-slate-800 disabled:text-slate-400"
      },
      {
        variant: "text",
        colorPalette: "blue",
        className: "bg-transparent text-blue-600 hover:text-blue-700 active:text-blue-800 disabled:text-slate-400"
      },
      {
        variant: "text",
        colorPalette: "green",
        className: "bg-transparent text-green-600 hover:text-green-700 active:text-green-800 disabled:text-slate-400"
      },
      {
        variant: "text",
        colorPalette: "warmGreen",
        className: "bg-transparent text-warmGreen-500 hover:text-warmGreen-600 active:text-warmGreen-700 disabled:text-slate-400"
      },
      {
        variant: "text",
        colorPalette: "orange",
        className: "bg-transparent text-orange-500 hover:text-orange-600 active:text-orange-700 disabled:text-slate-400"
      },
      {
        variant: "text",
        colorPalette: "red",
        className: "bg-transparent text-red-500 hover:text-red-600 active:text-red-700 disabled:text-slate-400"
      }
    ],
    defaultVariants: {
      variant: "solid",
      size: "md",
      colorPalette: "blue"
    }
  }
);
export {
  buttonVariants
};
